import posthog from 'posthog-js'

export function initPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY
  if (!key) return
  posthog.init(key, {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: true,
    advanced_disable_feature_flags: true,
  })
}

function track(event: string, params?: Record<string, unknown>) {
  try {
    posthog.capture(event, params)
  } catch {
    // Analytics unavailable
  }
}

export function trackSignUp() {
  track('sign_up')
}

export function trackLogin() {
  track('login')
}

export function trackExportReport() {
  track('export_report')
}

export function trackSubscriptionView() {
  track('subscription_view')
}

export function trackSubscriptionPurchase(tier: string, period: string) {
  track('subscription_purchase', { tier, period })
}

export function trackCalculatorUse(calculatorType: string) {
  track('calculator_use', { calculator_type: calculatorType })
}

export function setAnalyticsUser(uid: string) {
  try {
    posthog.identify(uid)
  } catch {
    // Analytics unavailable
  }
}
